module.exports = __webpack_public_path__ + "img/wabi.8ae6b6ec.gif";